/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    openingHours: {
        id: 'MerchantDetails.openingHours',
        defaultMessage: 'Opening hours',
    },
    ownPackagingTitle: {
        id: 'MerchantDetails.ownPackagingTitle',
        defaultMessage: 'Use your own packaging',
    },
    preorderTitle: {
        id: 'MerchantDetails.preorderTitle',
        defaultMessage: 'Pre-ordering allowed',
    },
    ownPackagingHelp: {
        id: 'MerchantDetails.ownPackagingHelp',
        defaultMessage: 'At this restaurant, you can opt for bringing your own packaging for picking up the ordered food.',
    },
    preorderHelp: {
        id: 'MerchantDetails.preorderHelp',
        defaultMessage: 'At this restaurant, you can choose a specific time for picking up your order.',
    },
    closeDialog: {
        id: 'MerchantDetails.closeDialog',
        defaultMessage: 'Close',
    },
});

export default messages;
